/* eslint-disable camelcase */
import { extend } from 'vee-validate'
import { required, email, alpha_num, image, numeric, confirmed, after, length, regex } from 'vee-validate/dist/rules'

extend('numeric', {
    ...numeric,
    message: '{_field_} cannot contain alphabets'
})

extend('regex', {
    ...regex,
    message: '{_field_} is invalid'
})

extend('length', {
    ...length,
    message: '{_field_} should have {length} digits'
})

extend('confirmed', {
    ...confirmed,
    message: '{_field_} does not match'
})

extend('required', {
    ...required,
    message: 'Required'
})

extend('checkbox', {
    validate (value) {
        if (value) {
            return true
        }
        return false
    },
    message: 'Please accept the {_field_}'
})

extend('lengthBetween', {
    validate (value, { minLength, maxLength }) {
        if (value.length >= minLength && value.length <= maxLength) {
            return true
        }
        return false
    },
    params: ['minLength', 'maxLength'],
    message: 'Length of {_field_} should be between {minLength} and {maxLength} digits'
})

extend('equal', {
    validate (value, { comparingString }) {
        if (value === comparingString) {
            return true
        }
        return false
    },
    params: ['comparingString', 'fieldName'],
    message: '{_field_} should match with {fieldName}'
})

extend('digits', {
    validate (value, { length }) {
        const isNum = /^\d+$/.test(value)
        if (!isNum) {
            return '{_field_} cannot contain alphabets'
        }
        return value.length === parseInt(length)
    },
    params: ['length'],
    message: '{_field_} should have {length} digits'
})

extend('alpha_num', {
    ...alpha_num,
    message: '{_field_} must contain only Alphanumeric characters'
})

extend('after', {
    ...after,
    validate (value, { prevDate }) {
        if (prevDate === '') {
            prevDate = new Date('2020-12-01')
        }
        return new Date(value) >= new Date(prevDate)
    },
    params: ['prevDate'],
    message: 'Date must be after "From Date"'
})

extend('image', {
    ...image,
    message: '{_field_} must be an image'
})

extend('length', {
    validate (value, { length }) {
        return value.length === parseInt(length)
    },
    params: ['length'],
    message: '{_field_} must have exactly {length} characters'
})

extend('email', {
    ...email,
    params: ['length'],
    message: 'Invalid Email'
})

extend('aadhaar', {
    validate (value) {
        const isNum = /^[0-9\s]*$/.test(value)
        if (!isNum || value.length !== 14) {
            return 'Invalid Aadhaar'
        } else {
            return true
        }
    },
    params: ['length']
})

extend('otp', {
    validate (value) {
        if ((value >= '0' && value <= '9')) {
            return true
        }
        return '{_field_} must contain only {length} numbers'
    },
    params: ['length']
})

extend('amountValidation', {
    validate (value, { maxAmount = Number.MAX_VALUE, minAmount = 1 }) {
        if (parseFloat(value) > maxAmount) {
            return '{_field_} cannot be greater than {maxAmount}'
        } else if (parseFloat(value) < minAmount) {
            return '{_field_} cannot be less than {minAmount}'
        }
        return true
    },
    params: ['maxAmount', 'minAmount']
})

extend('paymentAmountValidation', {
    validate (value, { maxAmount = Number.MAX_VALUE, minAmount = 1, firstTime = false, investedAmount = 0, investmentAmountLocale = 0 }) {
        if (parseFloat(value) > maxAmount && firstTime === 'true') {
            return 'Due to high demand we are restricting fresh investments per account to INR 50 Lakh.  Please note that it may take up to 3 weeks to fully deploy your investment into loans.'
        } else if (parseFloat(value) > parseFloat(maxAmount) && firstTime === 'false') {
            if (parseFloat(investedAmount) === 0) {
                return 'Due to high demand we are restricting fresh investments per account to INR 50 Lakh.  Please note that it may take up to 3 weeks to fully deploy your investment into loans.'
            } else {
                return 'You have already invested {investmentAmountLocale} in this month and due to high demand we are restricting fresh investments per account per month to INR 50 Lakh.  Please note that it may take up to 3 weeks to fully deploy your investment into loans.'
            }
        } else if (parseFloat(value) < parseFloat(minAmount)) {
            return '{_field_} cannot be less than {minAmount} for a month'
        }
        return true
    },
    params: ['maxAmount', 'minAmount', 'firstTime', 'investedAmount', 'investmentAmountLocale']
})

extend('amountValidationLocale', {
    validate (value, { maxAmount = Number.MAX_VALUE, minAmount = 1 }) {
        value = parseFloat(value.replaceAll(',', ''))
        if (parseFloat(value) > maxAmount) {
            return '{_field_} cannot be greater than {maxAmount}'
        } else if (parseFloat(value) < minAmount) {
            return '{_field_} cannot be less than {minAmount}'
        }
        return true
    },
    params: ['maxAmount', 'minAmount']
})
